import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const DocumentFavorite = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = '#FF2B35', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 25 24"
      fill="none"
      {...rest}
    >
      <path
        d="M22.9331 10V15C22.9331 20 20.9331 22 15.9331 22H9.93311C4.93311 22 2.93311 20 2.93311 15V9C2.93311 4 4.93311 2 9.93311 2H14.9331"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9331 10H18.9331C15.9331 10 14.9331 9 14.9331 6V2L22.9331 10Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.55289 15.7301C7.22289 14.7001 7.61289 13.4301 8.68289 13.0801C9.25289 12.9001 9.95289 13.0501 10.3429 13.6001C10.7129 13.0301 11.4429 12.9001 12.0029 13.0801C13.0829 13.4301 13.4629 14.7001 13.1429 15.7301C12.6329 17.3601 10.8429 18.2101 10.3429 18.2101C9.85289 18.2001 8.08289 17.3701 7.55289 15.7301Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DocumentFavorite.displayName = 'DocumentFavorite';
